import React from 'react';

export default function ReturnsRefunds() {
  return (
    <div className="policy-page" style={{
      maxWidth: '900px',
      margin: '20px auto',
      background: '#ffffff',
      borderRadius: '12px',
      padding: '24px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
    }}>
      <h1 style={{ marginTop: 0 }}>Refund & Cancellation Policy</h1>

      <p>
        We want you to be fully satisfied with your purchase from Shopie Bazar. If you are not
        happy with your order, please review our policy below and contact us for assistance.
      </p>

      <h3>Eligibility for Return</h3>
      <ul>
        <li>Items must be in unused, original condition with all tags and packaging.</li>
        <li>Initiate a return request within 7 days of delivery.</li>
        <li>Certain items (e.g., perishable goods, hygiene items, customized orders) may be non-returnable.</li>
      </ul>

      <h3>Return Process</h3>
      <ol>
        <li>Contact our support at <a href="mailto:support@shopiebazar.com">support@shopiebazar.com</a> with your order ID and reason.</li>
        <li>We will confirm eligibility and arrange pickup or share the return address.</li>
        <li>Pack the product securely to avoid transit damage.</li>
      </ol>

      <p>
        The returns would happen within <strong>7 to 10 days</strong> and also the damaged and defective items
        would be processed within <strong>5 to 7 days</strong>.
      </p>

      <h3>Refunds</h3>
      <ul>
        <li>Once we receive and inspect the item, refunds are processed to the original payment method.</li>
        <li>The refunded amount would be credited to the customer's bank account within <strong>7 to 10 days</strong>.</li>
        <li>Shipping charges are non-refundable unless the item was defective or incorrect.</li>
      </ul>

      <h3>Replacements</h3>
      <p>
        If you received a defective or wrong item, we will offer a replacement at no additional cost
        or a full refund, as per your preference and availability.
      </p>

      <h3>Cancellation Policy</h3>
      <p>
        You can cancel your order before it is shipped. Once the order is dispatched, cancellation is not possible,
        but you may return the item as per our return policy.
      </p>
      <ul>
        <li>Orders can be cancelled within <strong>24 hours</strong> of placing the order if not yet shipped.</li>
        <li>To cancel, contact us immediately at <a href="mailto:support@shopiebazar.com">support@shopiebazar.com</a> or call <a href="tel:+911169266020">+91 1169266020</a>.</li>
        <li>If payment was made online, the refund will be processed within <strong>7 to 10 business days</strong>.</li>
        <li>For Cash on Delivery (COD) orders, no refund is applicable as payment has not been made.</li>
        <li>Once the order is shipped or out for delivery, cancellation is not available. You may refuse delivery or initiate a return after receiving the product.</li>
      </ul>

      <h3>Contact</h3>
      <p>
        For any queries, please reach out to <a href="mailto:support@shopiebazar.com">support@shopiebazar.com</a>
        or call <a href="tel:+911169266020">+91 1169266020</a>.
      </p>

      <p style={{ opacity: 0.8, fontSize: '12px' }}>
        Note: This policy is subject to change. Please refer to this page for the latest version.
      </p>
    </div>
  );
}
